import React from 'react';
import { Route } from '@/navigation/Route';
import { ChargebackScreen } from './screens';

export const CHARGEBACK_ROUTES = {
  itself: '/support/chargeback',
};

export const ChargebackNavigation = (): JSX.Element => (
  <Route exact path={CHARGEBACK_ROUTES.itself} component={ChargebackScreen} isPrivateRoute />
);
